import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  AddAlert,
  Button,
  IcoContinue,
  IcoDownloadPDF,
  IcoPencilEditStudy,
  IcoTrashCanOutline,
} from '../../../../component';
import useOutsideClick from '../../../../hooks/useOusideClick/useoutsideclick';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { downloadPDFFromBase64 } from '../../../../shared/utils/exporter';
import {
  clearMap,
  modalOpen,
  setDisplayStudyCreationGuide,
  setIsActive,
  setIsActiveRightSidebar,
  setIsLoadingMap,
} from '../../redux/dashboardActions';
import nls from '../nls/pt-BR.json';
import {
  ApiKeys,
  API_CURRENT_STEP_KEYS_MAPPER,
} from '../redux/studies.constants';
import { getPDFReport, getStudyById } from '../redux/studies.controller';
import { StudiesStatuses, Study, Step } from '../redux/studies.model';
import {
  advanceToStep,
  closeAllDropdowns,
  setCurrentProgressTo,
  setInitialStep,
  setSelectedStudy,
  setStudy,
  studiesSelector,
} from '../redux/studies.reducer';

const handleClickEdit = () => (dispatch: any) => {
  dispatch([modalOpen('edit study modal'), closeAllDropdowns()]);
};

const handleClickDelete = () => (dispatch: any) => {
  dispatch([modalOpen('confirm delete study modal'), closeAllDropdowns()]);
};

const Dropdown: React.FC = () => {
  const { selectedStudy } = useTypedSelector(studiesSelector);
  const dispatch = useDispatch();
  const dropdownStatusMapper = {
    in_progress: <DropdownIncompleteStudy />,
    incomplete: <DropdownIncompleteStudy />,
    finished: <DropdownCompleteStudy />,
  };
  const ref = useRef(null);
  useOutsideClick(ref, () =>
    dispatch([closeAllDropdowns(), setSelectedStudy(null)])
  );
  return (
    <div className="dropdown" ref={ref}>
      {dropdownStatusMapper[selectedStudy?.status as StudiesStatuses]}
    </div>
  );
};

const DropdownIncompleteStudy: React.FC = () => {
  const { selectedStudy, currentStep } = useTypedSelector(studiesSelector);
  const dispatch = useDispatch();
  const handleClickContinue = async () => {
    dispatch(loading());
    try {
      if (selectedStudy) {
        const study: any = await getStudyById(selectedStudy?.id);

        if (study) {
          dispatch([
            clearMap(),
            setIsActive({ name: 'menuAction', value: '0' }),
            setIsActiveRightSidebar({ name: 'menuAction', value: '0' }),
            setStudy(study),
            setDisplayStudyCreationGuide(true),
            advanceToStep(
              API_CURRENT_STEP_KEYS_MAPPER[study.current_step as ApiKeys]
            ),
            setInitialStep(
              API_CURRENT_STEP_KEYS_MAPPER[study.current_step as ApiKeys]
            ),
            closeAllDropdowns(),
          ]);
          if (currentStep.step)
            dispatch(setCurrentProgressTo(currentStep.step));
        }
      }
    } catch (e) {
      dispatch(AddAlert('warning', 'Erro ao carregar estudo'));
    } finally {
      dispatch(loaded());
    }
  };
  return (
    <>
      <Button
        type="link"
        cy="DropdownIncompleteStudy"
        onClick={handleClickContinue}
      >
        <IcoContinue cy="DropdownIncompleteStudy" />
        {nls.dropdown.continue}
      </Button>
      <Button
        type="link"
        cy="EditIncompleteStudy"
        onClick={() => dispatch(handleClickEdit())}
      >
        <IcoPencilEditStudy
          style={{ color: '#525A66' }}
          cy="DropdownIncompleteStudy"
        />
        {nls.dropdown.edit}
      </Button>
      <Button
        type="link"
        style={{ color: '#FF1F1F' }}
        cy="DeleteIncompleteStudy"
        onClick={() => dispatch(handleClickDelete())}
      >
        <IcoTrashCanOutline
          style={{ width: 16, height: 16 }}
          cy="DropdownIncompleteStudy"
        />
        {nls.dropdown.delete}
      </Button>
    </>
  );
};

const DropdownCompleteStudy: React.FC = () => {
  const { selectedStudy } = useTypedSelector(studiesSelector);
  const dispatch = useDispatch();
  const handleDownload = async () => {
    try {
      dispatch(setIsLoadingMap(true));
      if (selectedStudy) {
        dispatch([closeAllDropdowns(), setSelectedStudy(null)]);
        const response = await getPDFReport(selectedStudy.id);
        downloadPDFFromBase64(response.data.file, selectedStudy.name);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setIsLoadingMap(false));
    }
  };
  return (
    <>
      <Button
        type="link"
        cy="EditCompleteStudy"
        onClick={() => dispatch(handleClickEdit())}
      >
        <IcoPencilEditStudy
          style={{ color: '#525A66' }}
          cy="DropdownCompleteStudy"
        />
        {nls.dropdown.edit}
      </Button>
      <Button
        type="link"
        cy="DownloadPDFCompleteStudy"
        onClick={handleDownload}
      >
        <IcoDownloadPDF cy="DropdownCompleteStudy" />
        {nls.dropdown.downloadPDF}
      </Button>
      <Button
        type="link"
        style={{ color: '#FF1F1F' }}
        cy="DeleteCompleteStudy"
        onClick={() => dispatch(handleClickDelete())}
      >
        <IcoTrashCanOutline
          style={{ width: 16, height: 16 }}
          cy="DropdownCompleteStudy"
        />
        {nls.dropdown.delete}
      </Button>
    </>
  );
};

export default Dropdown;
